import Vue from 'vue';

const success = ({ data }) => data.data.next_batch_number;

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => Vue.$http.get('/production/next_batch_number')
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      }))
);



// WEBPACK FOOTER //
// ./src/app/services/batch/nextBatchNumber.js